/**
 * Parametry zapytania z adresu ekranu — react-admin prowadzi trasy w części
 * po `#` (`HashRouter`), więc `?caretaker=…` stoi tam, a nie w
 * `location.search` (pulpity FTL, makieta back office v2, A4, 20.10.2026:
 * kafelek otwiera harmonogram floty i stronę powiadomień z filtrem w adresie).
 * Bez części po `#` — zwykłe `location.search`. Bez okna — pusto.
 */
export function hashQueryParams(): URLSearchParams {
  if (typeof window === 'undefined') return new URLSearchParams();
  const { hash, search } = window.location;
  const i = hash.indexOf('?');
  if (i >= 0) return new URLSearchParams(hash.slice(i + 1));
  return new URLSearchParams(search);
}
